import script from "./Calendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Calendar.vue?vue&type=script&lang=ts&setup=true"

import "./Calendar.vue?vue&type=style&index=0&id=7b85260e&lang=scss"

const __exports__ = script;

export default __exports__